import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/cn';

// The compact CTA at the end of an ops table row. `solid` is the primary action;
// the outlined tones are available but not the thing to do next.
export const actionButtonVariants = cva(
  'inline-flex h-[29px] items-center justify-center whitespace-nowrap rounded-[8px] px-4 font-dusq text-[12px] font-medium transition-transform active:scale-[0.98] motion-reduce:active:scale-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dusq-accent disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      tone: {
        solid: 'bg-dusq-emphasis-high text-dusq-emphasis-high-dark hover:bg-dusq-emphasis-mid',
        positive: 'border border-dusq-positive text-dusq-positive hover:bg-dusq-positive/10',
        negative: 'border border-dusq-negative text-dusq-negative hover:bg-dusq-negative/10',
        neutral: 'border border-dusq-border text-dusq-grey400 hover:text-dusq-text',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
);

export const ActionButton = React.forwardRef(({ className, tone, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className={cn(actionButtonVariants({ tone }), className)}
    {...props}
  />
));
ActionButton.displayName = 'ActionButton';
